import { Avatar, Box, Typography } from "@mui/material";
import { useAppSelector } from "../../../hooks/redux";

const ProfileItemView = () => {
  const { firstName, lastName, avatarLink, role } = useAppSelector((state) => state.users.info);

  return (
    <Box
      sx={{
        columnGap: "15px",
        alignItems: "center",
        placeItems: "center",
      }}
    >
      <Avatar
        sx={{ backgroundColor: "var(--accent)", width: "92px", height: "92px", mb: "16px" }}
        alt={`${firstName} ${lastName}`}
        src={avatarLink}
      />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography className="default-label-text strong" sx={{ fontSize: "24px !important" }}>
          {firstName} {lastName}
        </Typography>
        {role && <Typography className="default-label-text sm">{role}</Typography>}
      </Box>
    </Box>
  );
};

export default ProfileItemView;
